import { CountryCode } from '../api-types/common';
import { LocalizedMessageId } from '../types';

export function getCountryMessageId(countryCode: CountryCode) {
  // TODO: because not all countries are present in translation file this line gives error
  return `common.country:${countryCode}` as LocalizedMessageId; /* satisfies MessageId */
}
